<template>
  <div class="modal_reports">
    <div class="header">
      <h4 class="title">
        Параметры отчёта
      </h4>
    </div>

    <div class="line">
      <div class="elem">
        <WrapDatePicker
            type="datetime"
            value_type="X"
            placeholder="Время"
            label="Время"
            v-model="report_params.date"
            :range="true"
            :confirm="true"
        />
      </div>
    </div>

    <div class="line">
      <div class="elem">
        <label> Колонки </label>
        <tree-select
            :options="column_list"
            placeholder="Колонки"
            v-model="report_params.columns"
            :multiple="true"
            :clearable="false"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line">
      <div class="elem">
        <label> Параметры </label>
        <tree-select
            :options="aggregate_list"
            placeholder="Параметры"
            v-model="report_params.aggregates"
            :multiple="true"
            :clearable="false"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line">
      <div class="elem">
        <label> Период </label>
        <tree-select
          :options="period_list"
          placeholder="Период"
          v-model="report_params.period"
          :multiple="false"
          :clearable="false"
          :max-height="200"
        />
      </div>
    </div>

    <div class="text-center buttons">
      <button
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="get_reports"
      >
        Запросить
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "ModalReports",
  components: {WrapDatePicker},
  props: ['device_ids'],

  data () {
    return {
      report_params: {
        date: null,
        period: "day",
        columns: [],
        aggregates: []
      },
    }
  },

  computed:{
    period_list(){
      return [
        {id: "day", label: "День"},
        {id: "month", label: "Месяц"}
      ]
    },
    column_list(){
      return [
        {id: "device.device_id", label: "ID"},
        {id: "device.deviceGroup.name", label: "Group"},
        {id: "device.placeOrLocation", label: "Location"} ,
        {id: "device.activeTariffication.status", label: "Tariffication"} ,
        {id: "device.deviceUptime.status", label: "Uptime"}
      ]
    },
    aggregate_list(){
      return [
        {id: "min", label: "min"},
        {id: "max", label: "max"},
        {id: "avg", label: "avg"} ,
        {id: "total", label: "total"},
      ]
    }

  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    get_reports(){
      let params = {}
      if (this.report_params.date) {
        params.date_from = Number(this.report_params.date[0])
        params.date_to = Number(this.report_params.date[1])
      }
      params.device_ids = this.device_ids
      params.columns = this.report_params.columns
      params.period = this.report_params.period
      this.$http.v1.getReports(params, (response) => {
        if (response.data) {
          this.global_notify('info', this.translate('custom.add_devices_success'))
          this.$store.dispatch('customListUpdate')
          this.$emit('close')
        }else{
          this.global_notify('danger', this.translate('custom.add_devices_error'))
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.modal_reports {
  padding: 10px;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      margin: 10px 0;
    }
  }

  .line {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .elem {
      width: 100%;
      min-width: 0;

      .vue-treeselect {
        margin-bottom: 10px;
      }
    }
  }

  .marginButton {
    margin: 5px;
  }
}
</style>
